import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Maps old ?tab=...&view=... query params to React Router paths */
const LEGACY_ROUTE_MAP: Record<string, string | ((params: URLSearchParams) => string)> = {
  // Dashboard
  'apex': '/',
  // Current Expense
  'currentExpense:transactions': '/expense/invoices',
  'currentExpense:te': '/expense/te',
  'currentExpense:recharge-actuals': '/expense/recharges',
  'currentExpense:accruals': '/expense/service/accruals',
  'currentExpense:postage': '/expense/service/postage',
  'currentExpense:depreciation': '/expense/service/depreciation',
  'currentExpense:mobile': '/expense/service/mobile',
  // Budget Planning
  'budgetPlan:io-plans': (p) => {
    const cycle = p.get('cycle');
    const io = p.get('io');
    if (cycle && io) return `/planning/io-plans/${cycle}/${io}`;
    if (cycle) return `/planning/io-plans/${cycle}`;
    return '/planning/io-plans';
  },
  'budgetPlan:mec': '/planning/mec',
  'budgetPlan:bridges': '/planning/bridges',
  'budgetPlan:one-pagers': '/planning/one-pagers',
  'budgetPlan:preso-view': '/planning/preso',
  'budgetPlan:travel-plans': '/planning/travel',
  // DISABLED: Pull Forwards (see docs/DISABLED_FEATURES.md #17)
  // 'budgetPlan:pull-forwards-owner': '/planning/pull-forwards',
  'budgetPlan:user-recharges-plan': '/planning/recharges',
  // Self Service
  'selfService:my-tickets': '/self-service/tickets',
  // Reporting
  'reporting:te-reports': '/reporting/te',
  'reporting:invoices-reports': '/reporting/invoices',
  'reporting:io-priority-report': '/reporting/io-priority',
  'reporting:report-builder': '/reporting/builder',
  // AI
  'aiAssistant': '/chat',
  // Admin
  'admin:users': '/admin/users',
  'admin:sessions': '/admin/sessions',
  'admin:activity-log': '/admin/activity-log',
  'admin:roles': '/admin/roles',
  'admin:user-types': '/admin/user-types',
  'admin:team-management': '/admin/teams',
  'admin:ios': '/admin/ios',
  'admin:gls': '/admin/gls',
  'admin:cost-centers': '/admin/cost-centers',
  'admin:vendors': '/admin/vendors',
  'admin:tags': '/admin/tags',
  'admin:planning': '/admin/planning-cycles',
  'admin:export-tab': '/admin/export',
  'admin:export': '/admin/export',
  // Legacy "Uploads" tab → Data section (Directory Import first); /admin/uploads has no React route
  'admin:uploads': '/admin/directory-import',
  'admin:data': '/admin/directory-import',
  'admin:error-logs': '/admin/errors',
  'admin:it-services': '/admin/it-services',
};

/**
 * Detects legacy ?tab=...&view=... URLs and redirects to the
 * equivalent React Router path. Renders nothing.
 */
export default function LegacyURLRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (!tab) return;

    const view = params.get('view');
    const key = view ? `${tab}:${view}` : tab;

    const route = LEGACY_ROUTE_MAP[key];
    if (route) {
      const path = typeof route === 'function' ? route(params) : route;
      navigate(path, { replace: true });
    }
  }, [location.search, navigate]);

  return null;
}
